module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_5010.be17882c.png";